import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable, interval, map, race } from 'rxjs';
import { UserService } from '../../../global-services/user.service';

@Injectable({
  providedIn: 'root'
})
export class AdminGuard implements CanActivate {

  constructor(
    private readonly _userService: UserService,
    private readonly _router: Router

  ) {

  }

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {

    return race(
      interval(5 * 1000).pipe(map(() => false)),
      this._userService.isAdminObs
    )
      .pipe(
        map((isAdmin) => isAdmin ? true : this._router.parseUrl(''))
      )
  }

}
